/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  HttpStatusCode,
} from "axios";

import { errors } from "../../constants";
import {
  ApiException,
  IApiError,
  RequestBodyModel,
  TApiSuccess,
} from "../../models";
import { clearStorageTokens, retryWithTokenRefresh } from "../auth";
import {
  getTokenIsRefreshing,
  refreshAccessToken,
} from "../auth/token-refresh.helpers";
import { Log } from "../log.helpers";
import { createApiErrorWithTranslation } from "./api-utils";

export const handleUnauthorizedResponseException = async <T>(
  e: AxiosError<IApiError, any>,
  axiosConfig: AxiosRequestConfig<RequestBodyModel>,
): Promise<Promise<AxiosResponse<TApiSuccess<T>, any>>> => {
  try {
    if (getTokenIsRefreshing()) {
      Log.debug(
        "Token refreshing already in progress in unauthorized handler, waiting...",
      );
      await refreshAccessToken();
    }

    return await retryWithTokenRefresh<TApiSuccess<T>>(axiosConfig);
  } catch (refreshError) {
    Log.debug("Refresh token failed", refreshError);

    const message =
      (e.response?.data?.message as string) ||
      e.message ||
      "Unknown authentication error";

    clearStorageTokens();

    throw new ApiException(
      createApiErrorWithTranslation({
        message,
        translationKey: errors.common.authenticationError,
      }),
      HttpStatusCode.Unauthorized,
    );
  }
};
